import { FC } from 'react';

import { Heading, Link } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { NamedIcon } from '@telialt/common-icon/src';
import { selectRentingPlanVASProducts } from '@telialt/utils/src/eshopSelectors';

import { useCartQuery } from '../../hooks/queries/useCartQuery';
import { RatePlanVasLegalText } from '../../product/LegalText';
import { ESHOP_TEST_ID } from '../../test/test-ids';
import { VasClickHandler } from './model';
import { PlanVas } from './PlanVas';
import { useRatePlanVas } from './useVasData';
import {
    RentVasDescription,
    RentVasList,
    RentVasListItem,
    RentVasSection,
    RentVasTitle,
} from './ValueAddedServices.styles';

export const RatePlanVasBlock: FC<VasClickHandler> = ({ onClick }) => {
    const { t } = useTranslations();
    const ratePlanVasList = useRatePlanVas();

    if (!ratePlanVasList?.length) {
        return null;
    }

    return (
        <PlanVas
            sectionTitle={t['eshop.product_page.vas.rate_plan_block.title']}
            vasList={ratePlanVasList}
            onClick={onClick}
            vasLegalText={<RatePlanVasLegalText />}
            data-test={ESHOP_TEST_ID.RATE_PLAN_VAS_BLOCK}
        />
    );
};

export const RentVasBlock: FC = () => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();
    const rentVasList = selectRentingPlanVASProducts(cart);

    if (!rentVasList?.length) {
        return null;
    }

    return (
        <RentVasSection data-test={ESHOP_TEST_ID.RENT_PLAN_VAS_BLOCK}>
            <Heading tag="h3" variant="title-100">
                {t['eshop.product_page.vas.rent_plan_block.title']}
            </Heading>
            <RentVasList>
                {rentVasList.map(({ title, description, iconType }, index) => (
                    <RentVasListItem key={[title, iconType].join('') || index}>
                        <NamedIcon name={iconType} size="lg" />
                        <RentVasTitle>{title}</RentVasTitle>
                        <RentVasDescription content={description} />
                    </RentVasListItem>
                ))}
            </RentVasList>
            <Link
                href={t['eshop.product_page.vas.rent_plan_block.link.href']}
                variant="text"
                target="_blank"
                disableVisited={true}
            >
                {t['eshop.product_page.vas.rent_plan_block.link.text']}
            </Link>
        </RentVasSection>
    );
};
